import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hint"]
  static values = { targetSelector: String }

  scrollElem = null

  connect() {
    if (!this.hasTargetSelectorValue && !this.hasHintTarget) return

    this.scrollElem = document.querySelector(this.targetSelectorValue)
    if (!this.scrollElem) return

    this.checkScroll()
    window.addEventListener("resize", this.checkScroll.bind(this))
  }

  disconnect() {
    window.removeEventListener("resize", this.checkScroll.bind(this))
  }

  checkScroll() {
    const hasHorizontalScroll = this.scrollElem.scrollWidth > this.scrollElem.clientWidth

    this.hintTarget.classList.toggle("hidden", !hasHorizontalScroll)
  }
}
